const NON_BREAKING_SPACE = '&nbsp;';
export default function preserveMarkdownLeadingAndTrailingWhitespace(markdown) {
    return ((markdown.startsWith(' ') ? NON_BREAKING_SPACE : markdown.slice(0, 1)) +
        markdown.slice(1, -1) +
        (markdown.endsWith(' ') ? NON_BREAKING_SPACE : markdown.slice(-1)));
}
//# sourceMappingURL=preserveMarkdownLeadingAndTrailingWhitespace.js.map